import styled, { css } from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import getBorderRadius from "../../../utils/getBorderRadius";
import getBoxShadow from "../../../utils/getBoxShadow";
import getColor from "../../../utils/getColor";
import space from "../../../utils/space";
import { sizes } from ".";
var StyledTextBoxAtm = styled.div.withConfig({
  componentId: "sc-etorm-0"
})(function (_ref) {
  var $size = _ref.$size,
    $backgroundColor = _ref.$backgroundColor,
    theme = _ref.theme;
  var _sizes$$size = sizes[$size],
    boxSizeSpace = _sizes$$size.boxSizeSpace,
    shadowSize = _sizes$$size.shadowSize,
    medium = _sizes$$size.medium;
  return css(["display:inline-flex;align-items:center;justify-content:center;width:", ";height:", ";padding:0;border-radius:", ";background-color:", ";box-shadow:", ";", ""], space(boxSizeSpace), space(boxSizeSpace), getBorderRadius(theme, "large"), getColor(theme, $backgroundColor), getBoxShadow(theme, shadowSize), medium && css(["", "{width:", ";height:", ";}"], breakpoint("medium"), space(medium.boxSizeSpace), space(medium.boxSizeSpace)));
});
export default StyledTextBoxAtm;